/* eslint-disable max-len */
export default function Privacy() {
  return (
    <main className="container mx-auto mb-auto">
      <div className="text-md py-8 max-w-[37.5rem] mx-auto p-8 flex flex-col gap-6">
        <div className="text-3xl font-extrabold m-auto text-center pt-10 pb-10">
          Privacy Policy of Alexandria
        </div>

        <div>
          <div className="text-secondary pb-4">
            Alexandria operates the https://tryalexandria.com/ website, which
            provides the SERVICE.
          </div>
          <div className="text-secondary pb-4">
            This page is used to inform website visitors regarding our policies
            with the collection, use, and disclosure of Personal Information if
            anyone decided to use our Service, the Alexandria website.
          </div>
          <div className="text-secondary pb-4">
            If you choose to use our Service, then you agree to the collection
            and use of information in relation with this policy. The Personal
            Information that we collect are used for providing and improving the
            Service. We will not use or share your information with anyone.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Information Collection and Use
          </div>
          <div className="text-secondary">
            For a better experience while using our Service, we may require you
            to provide us with limited personally identifiable information,
            including your name and email address. The information that we
            collect will be used to provide you with a better experience on
            Alexandria.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Log Data
          </div>
          <div className="text-secondary">
            We want to inform you that whenever you visit our Service, we
            collect information that your browser sends to us that is called Log
            Data. This Log Data may include information such as your computer’s
            Internet Protocol ("IP") address, browser version, pages of our
            Service that you visit, the time and date of your visit, the time
            spent on those pages, and other statistics.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Cookies
          </div>
          <div className="text-secondary">
            Cookies are files with small amount of data that is commonly used an
            anonymous unique identifier. These are sent to your browser from the
            website that you visit and are stored on your computer’s hard drive.
          </div>
          <div className="text-secondary">
            Our website uses these "cookies" to collection information and to
            improve our Service.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Security
          </div>
          <div className="text-secondary">
            We value your trust in providing us your Personal Information, thus
            we are striving to use commercially acceptable means of protecting
            it. But remember that no method of transmission over the internet,
            or method of electronic storage is 100% secure and reliable, and we
            cannot guarantee its absolute security.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Children's Privacy
          </div>
          <div className="text-secondary">
            Our Services do not address anyone under the age of 13. We do not
            knowingly collect personal identifiable information from children
            under 13. In the case we discover that a child under 13 has provided
            us with personal information, we immediately delete this from our
            servers. If you are a parent or guardian and you are aware that your
            child has provided us with personal information, please{' '}
            <a
              className="underline decoration-2 decoration-sky-600"
              href="mailto:support@tryalexandria.com"
            >
              contact us
            </a>{' '}
            so that we will be able to do necessary actions.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Changes to This Privacy Policy
          </div>
          <div className="text-secondary">
            We may update our Privacy Policy from time to time. Thus, we advise
            you to review this page periodically for any changes. We will notify
            you of any changes by posting the new Privacy Policy on this page.
            These changes are effective immediately, after they are posted on
            this page.
          </div>
        </div>

        <div>
          <div className="text-lg font-medium leading-6 text-tertiary mt-3 pb-4">
            Contact Us
          </div>
          <div className="text-secondary">
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to{' '}
            <a
              className="underline decoration-2 decoration-sky-600"
              href="mailto:support@tryalexandria.com"
            >
              contact us
            </a>
            .
          </div>
        </div>
      </div>
    </main>
  );
}
